import React from "react"
import styled from "styled-components"
export const Vimeo = (props) => {
    const ratio = (props.ratio) ? props.ratio : 56.25;
    return (
        <div className="vimeo" style={{ padding: `${ratio}% 0 0 0`, position: "relative"}}><iframe title='Video' src={`https://player.vimeo.com/video/${props.id}?title=0&byline=0&portrait=0&sidedock=0`} style={{position: "absolute", top: 0, left:0, width: "100%", height: "100%"}} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen></iframe></div>
    );
}


const StyledFigure = styled.figure`
  figcaption {
    margin-top: 1rem;
    font-size: var(--fontSizeS);
    line-height: 1.2rem;
  }
`

export const Figure = (props) => {
  return (
    <StyledFigure>
      {props.children}
      <figcaption>{props.caption}</figcaption>
    </StyledFigure>
  );
}

export const FullWidth = styled.div`
  margin-top: 2rem;
  h2, h3, h4, p, ul, ol {
    max-width: 100%;
  }
`

export const Demo = styled.div`
    h3 {
      margin-bottom: 1rem;
    }
    margin-top: 2rem;
    background: var(--white);
    padding: 0.5rem;
    /* box-shadow: 0 10px 20px rgba(0,0,0,0.2); */
    border-radius: 8px;
`

const StyledBox = styled.div`
  padding: 1.2rem;
  font-size: var(--fontSizeS);
  background: var(--white);
  /* box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.07); */
  /* border: 1px solid #eee; */
  text-align: center;
  border-radius: 1rem;
  height: 100%;
  .icon {
    font-size: 4rem;
    margin-top: 0;
    padding: 0.5rem;
    display: inline-block;
  }
  h3 {
    font-size: var(--fontSizeM);
    font-weight: var(--medium);
    margin-top: var(--stackSpacingS);
  }
  &.caption {
    display: flex;
    flex-direction: column;
    .center {

      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      /* align-items: center; */
      * > :first-child {
          margin-top: 0;
        }
    }
    h4 {
      flex-grow: 0;
      padding-top: 1rem;
      color: var(--darkGray);
      font-weight: var(--medium);
      margin-top: 1rem;
      font-size: var(--fontSizeXS);
    }
  }
  
  
`

export const Box = (props) => {
  return (
  <StyledBox className={props.caption && 'caption'}>
    {props.caption ? <div className="center"><div className="child">{props.children}</div></div> : props.children}
    {props.caption && <h4>{props.caption}</h4>}
  </StyledBox>
  );
}

export const VideoBox = styled(StyledBox)`
  margin-top: 2rem;
  .vimeo {
    margin-top: 0;
  }
`;



export const Persona = styled(StyledBox)`
  width: 100%;
  text-align: left;
  /* .gatsby-resp-image-wrapper {
    border-radius: 1rem;
  } */
  .gatsby-resp-image-wrapper {
    border-radius: 0.5rem;
  }
  h3 {
    margin-top: 1rem;
    font-weight: var(--medium);
    font-size: var(--fontSizeM);
  }
  h4 {
    margin-top: 1.2rem;
    color: var(--darkGray);
    font-size: var(--fontSizeXS);
    font-weight: var(--medium);
  }
  h4 + ul, h4 + ol {
    margin-top: 0.5rem;
    li {
      margin-top: 0.3rem;
    }
  }
  p {
    margin-top: 0.5rem;
    &:first-child {
      margin-top: 0;
    }
    
  }
  
`

export const Avatar = styled.div`
  .gatsby-resp-image-wrapper, img {
    border-radius: 50%;
    overflow: hidden;
  }
  
  
`